import React from "react";

import Input from "../theme/forms/Input";
import ColorCheckbox from "../theme/forms/ColorCheckbox";

export default class CanvasserFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //canvasser filters
      showFilters: false,
      showAssignedCanvassers: true,
      availableCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      displayedCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
    };

    this.colorClassMapping = {
      checked_in: { class: "_green", color: "#33a02c" },
      not_checked_in: { class: "_red", color: "#e31a1c" },
      unscheduled: { class: "_grey", color: "darkgrey" },
      assigned: { class: "_blue", color: "#1f78b4" },
    };
  }

  _handleLegendCheckboxToggle = (status) => {
    //check if status is in display
    let new_displayed_statuses;
    if (this.state.displayedCanvasserStatuses.includes(status)) {
      new_displayed_statuses = this.state.displayedCanvasserStatuses.filter(
        (d) => d !== status
      );
    } else {
      new_displayed_statuses = [
        ...this.state.displayedCanvasserStatuses,
        status,
      ];
    }

    this.setState({ displayedCanvasserStatuses: new_displayed_statuses }, () =>
      this.handleChange()
    );
  };

  handleChange() {
    this.props.handleFilterUpdate(
      this.state.displayedCanvasserStatuses,
      this.state.showAssignedCanvassers
    );
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters });
  }

  render() {
    return (
      <React.Fragment>
        <div
          className={"button button-clear mb-0 px-0 py-2 primary-text"}
          onClick={() => this.toggleFilters()}
        >
          {this.state.showFilters ? "Hide Filters" : "Show Filters"}
        </div>

        <div className={"wrapper"} style={{ display: this.state.showFilters ? "block" : "none" }}>
          <Input
            type={"checkbox"}
            key={Math.random()}
            value={this.state.showAssignedCanvassers}
            defaultChecked={this.state.showAssignedCanvassers}
            onChange={() =>
              this.setState({
                showAssignedCanvassers: !this.state.showAssignedCanvassers,
              })
            }
            title={"Show Assigned"}
            style={{ marginBottom: "1px" }}
          />

          {this.state.availableCanvasserStatuses.map((d) => {
            return (
              <ColorCheckbox
                className={this.colorClassMapping[d].class}
                handleChange={() => this._handleLegendCheckboxToggle(d)}
                value={this.state.displayedCanvasserStatuses.includes(d)}
                title={
                  d.charAt(0).toUpperCase() + d.slice(1).replace(/_/g, " ")
                }
                key={d}
                style={{ transform: "scale(.85)" }}
              />
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}
